//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalAmountApproved = ({ count }: { count: string | number }) => {
  return <StatCard title='Total Amount Approved' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalAmountApproved;
